/* NW sengeguide: live priser og lagerkontrol paa tilvalg. Tilfoejet 28-08-2026.

   BAGGRUND 1, PRISER: guidens pristabeller var praecis 80% af Shopify-prisen paa
   tvaers af alle materialer og alle tilvalg, og hovedpuden stod til 119 kr mod 449 kr.
   Guiden lovede 1.357 kr hvor kurven tog 1.697 kr. Fejlen var usynlig indtil kurven.
   En faelles pristabel pr. materiale kan desuden aldrig blive rigtig, fordi
   TC400-farverne koster mere end de oevrige bambusfarver og mangler 240x220.

   BAGGRUND 2, LAGER: tilvalgene blev prissat og talt med i totalen, men droppet
   tavst fra kurven hvis varianten var udsolgt eller slet ikke fandtes. Sortimentet
   er tyndt: 90x210 har intet lagen overhovedet, og flere farver har kun 90x200.

   BAGGRUND 3, RETTET 31-08-2026: lagerkontrollen hang KUN paa renderResult. Men guidens
   klik-handlere kalder refresh(), som gentegner #addons uden at gaa gennem renderResult.
   Slog brugeren selv lagenet til, blev der derfor aldrig tjekket lager igen, og guiden
   kunne love et udsolgt lagen. Fundet da et gemt saet viste "Udsolgt lige nu" paa
   favoritlisten. Vi lytter nu OGSAA paa aendringer i #addons.

   Handles til lagen og pudebetraek hentes fra nw-sg-tilvalg.js, saa pris, lager,
   visning og kurv altid peger paa det samme materiale. */
(function(){
  'use strict';

  var PUDE_H = "bambus-hovedpude-vile";
  var SIMPLE_H = { vaskemiddel: "vaskemiddel-500ml", vaskepose: "vaskepose-40x50" };
  var DYNE_H = { embla: "bambusdyne", silkebom: "silkedyne-med-bomuldsvar", silkesilke: "dyne" };

  var cache = {}, henter = {}, venter = false, hooket = false, addonsHooket = false;

  function norm(s){ return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '').replace(/cm/g, ''); }
  function kr(oere){ return Math.round(Number(oere || 0) / 100); }

  function lagenHandles(typ){
    try{
      if(window.nwSgTilvalg){ return window.nwSgTilvalg.lagenHandles(chosen.mat, typ) || []; }
    }catch(e){}
    return [];
  }
  function pbHandles(){
    try{
      if(window.nwSgTilvalg){ return window.nwSgTilvalg.pbHandles(chosen.mat) || []; }
    }catch(e){}
    return [];
  }

  function hent(h){
    if(!h || cache[h] !== undefined || henter[h]){ return; }
    henter[h] = true;
    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ cache[h] = p || null; henter[h] = false; planlaeg(); })
      .catch(function(){ cache[h] = null; henter[h] = false; planlaeg(); });
  }

  function variantFor(p, st){
    if(!p || !p.variants){ return null; }
    var n = norm(st), i, j;
    for(i = 0; i < p.variants.length; i++){
      var o = p.variants[i].options || [];
      for(j = 0; j < o.length; j++){ if(norm(o[j]) === n){ return p.variants[i]; } }
    }
    for(i = 0; i < p.variants.length; i++){
      if(norm(p.variants[i].title).indexOf(n) === 0){ return p.variants[i]; }
    }
    if(p.variants.length === 1){ return p.variants[0]; }
    return null;
  }

  function kanLeveres(handle, stoerrelse){
    var p = cache[handle];
    if(!p){ return false; }
    var v = variantFor(p, stoerrelse);
    return !!(v && v.available !== false);
  }

  function alleHentet(liste){
    return liste.length > 0 && liste.every(function(h){ return cache[h] !== undefined; });
  }

  function planlaeg(){
    if(venter){ return; }
    venter = true;
    setTimeout(function(){ venter = false; pas(); }, 0);
  }

  window.nwSgVariant = function(handle, stoerrelse){
    hent(handle);
    var p = cache[handle];
    if(!p){ return null; }
    return variantFor(p, stoerrelse);
  };

  function pas(){
    if(typeof chosen === 'undefined' || !chosen || !chosen.mat){ return; }
    var aendret = false;

    /* 1. Sengetoejet. Baade priser og hvilke stoerrelser der findes for farven. */
    try{
      var cols = materials[chosen.mat].colors;
      cols.forEach(function(c){ hent(c.handle); });
      var p = cache[cols[chosen.color].handle];
      if(p){
        var nye = [];
        allSizes.forEach(function(s){
          var v = variantFor(p, s.id);
          if(v){ nye.push({ v: s.id, price: kr(v.price) }); }
        });
        if(nye.length){
          var gl = materials[chosen.mat].sizes || [];
          var a = gl.map(function(x){ return x.v + ':' + x.price; }).join('|');
          var b = nye.map(function(x){ return x.v + ':' + x.price; }).join('|');
          if(a !== b){ materials[chosen.mat].sizes = nye; aendret = true; }
          if(!nye.some(function(x){ return norm(x.v) === norm(chosen.size); })){
            chosen.size = nye[nye.length - 1].v;
            aendret = true;
          }
        }
      }
    }catch(e){}

    /* 2. Lagen: priser, og derefter om det overhovedet kan leveres. */
    try{
      if(chosen.lagen){
        var typ = (chosen.lagen.type === 'kuvert') ? 'kuvert' : 'box';
        var liste = lagenHandles(typ);
        liste.forEach(function(h){ hent(h); });

        var lp = cache[liste[chosen.lagen.ci || 0]];
        if(lp){
          lagenSizes.forEach(function(row){
            var v = variantFor(lp, row.v);
            var ny = v ? kr(v.price) : 0;
            if(row[typ] !== ny){ row[typ] = ny; aendret = true; }
          });
        }

        /* Lov ikke et lagen vi ikke kan levere. Skift til naermeste farve der
           findes paa lager i den valgte stoerrelse, ellers slaa tilvalget fra. */
        if(chosen.lagen.on && alleHentet(liste)){
          var st = chosen.lagen.size || chosen.size;
          if(!kanLeveres(liste[chosen.lagen.ci || 0], st)){
            var fundet = -1;
            for(var q = 0; q < liste.length; q++){
              if(kanLeveres(liste[q], st)){ fundet = q; break; }
            }
            if(fundet >= 0){ chosen.lagen.ci = fundet; aendret = true; }
            else { chosen.lagen.on = false; aendret = true; }
          }
        }
      }
    }catch(e){}

    /* 3. Pudebetraek: samme behandling. */
    try{
      if(chosen.pb){
        var pbl = pbHandles();
        pbl.forEach(function(h){ hent(h); });
        var pp = cache[pbl[chosen.pb.ci || 0]];
        if(pp){
          pbSizes.forEach(function(row){
            var v = variantFor(pp, row.v);
            var ny2 = v ? kr(v.price) : 0;
            if(row.price !== ny2){ row.price = ny2; aendret = true; }
          });
        }
        if(chosen.pb.qty > 0 && alleHentet(pbl)){
          var pst = chosen.pb.size || '60×63';
          if(!kanLeveres(pbl[chosen.pb.ci || 0], pst)){
            var pf = -1;
            for(var w = 0; w < pbl.length; w++){
              if(kanLeveres(pbl[w], pst)){ pf = w; break; }
            }
            if(pf >= 0){ chosen.pb.ci = pf; aendret = true; }
            else { chosen.pb.qty = 0; aendret = true; }
          }
        }
      }
    }catch(e){}

    /* 4. Hovedpuden. Samme pude uanset materiale, det er en pude og ikke et betraek. */
    try{
      hent(PUDE_H);
      var pu = cache[PUDE_H];
      if(pu && pu.variants && pu.variants[0]){
        var np = kr(pu.variants[0].price);
        if(PUDE_PRICE !== np){ PUDE_PRICE = np; aendret = true; }
        if(chosen.pude && chosen.pude.qty > 0 && !pu.variants.some(function(v){ return v.available; })){
          chosen.pude.qty = 0;
          aendret = true;
        }
      }
    }catch(e){}

    /* 5. Vaskemiddel og vaskepose. Udsolgte fjernes helt fra listen. */
    try{
      simpleAddons.slice().forEach(function(sa){
        var h = SIMPLE_H[sa.key];
        hent(h);
        var sp = cache[h];
        if(!sp){ return; }
        if(!(sp.variants || []).some(function(v){ return v.available; })){
          var ix = simpleAddons.indexOf(sa);
          if(ix >= 0){
            simpleAddons.splice(ix, 1);
            if(chosen.simple){ chosen.simple[sa.key] = false; }
            aendret = true;
          }
          return;
        }
        var sn = kr(sp.variants[0].price);
        if(sa.price !== sn){ sa.price = sn; aendret = true; }
      });
    }catch(e){}

    /* 6. Dyner */
    try{
      dyneOptions.forEach(function(o){
        var dh = DYNE_H[o.key];
        hent(dh);
        var dp = cache[dh];
        if(!dp){ return; }
        Object.keys(o.sizes).forEach(function(k){
          var v = variantFor(dp, k);
          if(v && o.sizes[k].price !== kr(v.price)){ o.sizes[k].price = kr(v.price); aendret = true; }
        });
      });
    }catch(e){}

    if(aendret && typeof renderResult === 'function'){
      try{ renderResult(); }catch(e){}
    }
  }

  /* Guidens klik-handlere kalder refresh(), som gentegner #addons UDEN at gaa gennem
     renderResult. Uden denne observer blev lageret aldrig tjekket igen, naar brugeren
     selv slog et tilvalg til eller skiftede farve og stoerrelse paa det. */
  function hookAddons(){
    if(addonsHooket){ return; }
    var box = document.getElementById('addons');
    if(!box){ return; }
    addonsHooket = true;
    try{
      new MutationObserver(function(){ planlaeg(); }).observe(box, { childList: true, subtree: true });
    }catch(e){}
  }

  function hook(){
    hookAddons();
    if(hooket){ return; }
    if(typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    var f = window.renderResult;
    window.renderResult = function(){
      var r = f.apply(this, arguments);
      planlaeg();
      return r;
    };
    planlaeg();
  }

  window.nwPrisPass = planlaeg;

  hook();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', hook); }
  window.addEventListener('load', hook);
  setTimeout(hook, 1500);
  setTimeout(hook, 3500);
  setTimeout(hook, 6000);
})();